module.exports = __webpack_public_path__ + "media/images/icons/handshake-8b61c022b99ed50c3d262dfb4b4144b9.svg";